import Finances from "../../views/modules/finances/Finances";
import CollectionList from "../../views/modules/finances/collections/ChargesTab";
// import CutAndReconnectList from "../../views/modules/finances/c&r/cut_and_reconnect/CutAndReconnectList";
// import ExceptionList from "../../views/modules/finances/c&r/exemptions/ExceptionList";
// import FinancialStatementList from "../../views/modules/finances/financial_statements/FinancialStatementList";
import CustomerList from "../../views/modules/finances/customers/CustomerList";
import DocumentList from "../../views/modules/finances/documents/DocumentList";
import NavisionLicence from "@/views/modules/finances/navision/NavisionLicence.vue";
import NavitionTransactions from "@/views/modules/finances/reports/NavitionTransactions";
import ElectronicComprobantEmitedByMonth from "@/views/modules/finances/reports/ElectronicComprobantEmitedByMonth.vue";
import ContractList from "../../views/modules/customer_service/contracts/ContractList";
import RequestList from "../../views/modules/technical_support/requests/RequestList";
import Exonerated from "@/views/modules/automatic_processes/cut_and_reconnection/Exonerated.vue";
import Record from "@/views/modules/automatic_processes/cut_and_reconnection/Record.vue";
import ReporteNcf from "@/views/modules/technical_support/reports/ReportNcfmovilToCut.vue";
// import notificionmagypago from "@/components/customer_service/Notificaciones/Notificaciones_magypago.vue";
// import ReportUsersToCut from "@/views/modules/technical_support/reports/ReportUsersToCut.vue";
// import Project from "@/views/modules/projects/Project.vue";
//import CashFlow from "@/views/modules/projects/CahsFlow.vue";
// import CashFlow2 from "@/views/modules/projects/CashFlow2.vue";
import CalendarFinances from "@/views/apps/calendar/CalendarFinances.vue";
import NavisionAndNavixy from "@/components/functionals/DifNavisionNavixyReport.vue";
//import ReportDevicesByClient from "@/views/modules/sales/reports/ReportDevicesByClients";
import EquipReport from "../../views/modules/operations/EquipReport.vue";

// reports

import layouts from "../../layout";

export default {
  path: "/finances",
  name: "finances",
  component: Finances,
  meta: {
    auth: true,
    title: "Finanzas",
    tags: ["finances"]
  },
  redirect: {
    name: "finances-customer"
  },
  children: [
    {
      path: "customers",
      name: "finances-customer",
      component: CustomerList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Customers",
        tags: ["finances", "customers"],
        index: true
      }
    },
    {
      path: "documents",
      name: "finances-documents",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Document",
        tags: ["finances", "documents"],
        index: true
      }
    },
    {
      path: "requests",
      name: "finances-requests",
      component: RequestList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Requests",
        tags: ["finances", "Requests"],
        index: true
      }
    },
    {
      path: "contracts",
      name: "finances-contracts",
      component: ContractList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Contracts",
        tags: ["finances", "contracts"],
        index: true
      }
    },
    {
      path: "navision-licence",
      name: "navision-licence",
      component: NavisionLicence,
      meta: {
        auth: true,
        searchable: true,
        title: "Navision Licence",
        tags: ["finances", "navision", "licence"],
        index: true
      }
    },
    {
      path: "collections",
      name: "finances-collection",
      component: CollectionList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Collections",
        tags: ["finances", "collection"],
        index: true
      }
    },

    {
      path: "report-accounts-payable",
      name: "report-accounts-payable-finances",
      component: () =>
        import(
          "../../views/modules/finances/reports/ReportAccountsPayable.vue"
        ),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Reporte de cuentas por pagar",
        tags: ["report", "finances", "list", "navition"],
        index: true
      }
    },
    {
      path: "calendar",
      name: "finances-calendar",
      component: CalendarFinances,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Calendar",
        tags: ["calendar"],
        index: true
      }
    },

    // {
    //   path: "cr/cut_and_reconnect",
    //   name: "finances-cut-and-reconnect",
    //   component: CutAndReconnectList,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Cut And Reconnect",
    //     tags: ["finances", "cutAndReconnect"],
    //     index: true
    //   }
    // },
    // {
    //   path: "cr/exceptions",
    //   name: "finances-cut-and-reconnect-exceptions",
    //   component: ExceptionList,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Exception",
    //     tags: ["finances", "cutAndReconnect", "exception"],
    //     index: true
    //   }
    // },
    // {
    //   path: "financial_statement",
    //   name: "finances-statement",
    //   component: FinancialStatementList,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Finance Statement",
    //     tags: ["finances", "financeStatement"],
    //     index: true
    //   }
    // },
    {
      path: "auto-process",
      name: "auto-process",
      component: {
        name: "AutoProcess",
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        title: "Auto Process"
      },
      children: [
        {
          path: "exonerated-cut",
          name: "exonerated-cut",
          component: Exonerated,
          meta: {
            auth: true,
            title: "Exonerated Cut",
            index: true
          }
        },
        {
          path: "record-cut-and-reconnection",
          name: "record-cut-and-reconnection",
          component: Record,
          meta: {
            auth: true,
            title: "Record cut and reconnection",
            index: true
          }
        },
        {
          path: "record-cut-and-reconnection-ncf",
          name: "record-cut-and-reconnection-ncf",
          component: ReporteNcf,
          meta: {
            auth: true,
            title: "Record cut and reconnection",
            index: true
          }
        },
        {
          path: "Notification-magypago-billing",
          name: "customer-service-notificationmagyBilling2",
          component: () =>
            import(
              "@/components/customer_service/Notificaciones/Notificaciones_magypago.vue"
            ),
          meta: {
            auth: true,
            title: "Notificaciones de facturacion en Magypago",
            index: true
          }
        }

        // {
        //   path: "report-users-to-cut",
        //   name: "report-users-to-cut",
        //   component: ReportUsersToCut,
        //   meta: {
        //     auth: true,
        //     title: "Report users to cut",
        //     index: true
        //   }
        // }
      ]
    },
    // {
    //   path: "cashflow",
    //   name: "cashflow",
    //   component: {
    //     name: "cashflow",
    //     render: (h) => h("router-view")
    //   },
    //   meta: {
    //     auth: true,
    //     title: "CashFlow"
    //   },
    //   children: [
    //     /*
    //     {
    //       path: "general-cashFlow",
    //       name: "general-cashFlow",
    //       component: CashFlow,
    //       meta: {
    //         auth: true,
    //         title: "General CashFlow",
    //         index: true
    //       }
    //     },
    //     */
    //     {
    //       path: "general-cashFlow", // general-cashFlow2
    //       name: "general-cashFlow", // general-cashFlow2
    //       component: CashFlow2,
    //       meta: {
    //         auth: true,
    //         title: "General CashFlow", // General CashFlow 2
    //         index: true
    //       }
    //     },
    //     {
    //       path: "project-cashFlow",
    //       name: "project-cashFlow",
    //       component: Project,
    //       meta: {
    //         auth: true,
    //         title: "Project CashFlow",
    //         index: true
    //       }
    //     }
    //   ]
    // },
    {
      path: "financesreports",
      name: "finances-reports",
      component: {
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        index: true,
        title: "Reports"
      },
      children: [
        {
          path: "report-devices-gps-finances",
          name: "report-gps-by-client-finances",
          component: () =>
            import(
              /* webpackChunkName: "ReportDevices" */ "@/views/modules/finances/reports/ReportDevicesByClients"
            ),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Reporte GPS Por Cliente",
            tags: ["report", "finances", "list", "devices", "GPS"],
            index: true
          }
        },
        {
          path: "report-terminals-finances",
          name: "report-terminals-by-client-finances",
          component: () => import("../../components/reports/ReportTerminals"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Reporte Terminales Por Cliente",
            tags: ["report", "finances", "list", "devices", "terminales"],
            index: true
          }
        },
        {
          path: "device_contracts",
          name: "technical-support-Report-Device-Contract",
          component: () =>
            import("@/views/apps/ncfmovil/TerminalsContract.vue"),
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Dispositivos por contrato",
            tags: ["report", "finances"],
            index: true
          }
        },
        {
          path: "electronic-comprobants-report",
          name: "electronic-comprobants-report-finances",
          component: ElectronicComprobantEmitedByMonth,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Reporte de Comprobantes Electronicos Emitidos",
            tags: ["report", "finances", "list", "comprobant", "electronic"],
            index: true
          }
        },
        {
          path: "navition-transactions-report",
          name: "navition-transactions-report-finances",
          component: NavitionTransactions,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Reporte de Transacciones en Navition",
            tags: ["report", "finances", "list", "navition"],
            index: true
          }
        },
        {
          path: "report-NavisionAndNavixy-Equipos",
          name: "report-NavisionAndNavixy-Equipos-finances",
          component: NavisionAndNavixy,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Reporte de diferencia de Equipos entre Navision y Navixy",
            tags: ["report", "finances", "list", "navition"],
            index: true
          }
        },
        {
          path: "DevicesReportsfinances",
          name: "devices-reports2-finances",
          component: EquipReport,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Reporte de Equipos",
            tags: ["technicalSupport", "slaconfigurations"],
            index: true
          }
        }
        // {
        //   path: "Notification-magypago-billing2",
        //   name: "customer-service-notificationmagyBilling2",
        //   component: () =>
        //     import(
        //       "@/components/customer_service/Notificaciones/Notificaciones_magypago.vue"
        //     ),
        //   meta: {
        //     auth: true,
        //     searchable: true,
        //     layout: layouts.navLeft,
        //     title: "Notificaciones de facturacion en Magypago",
        //     tags: ["customerService", "FacturacionNavixy"],
        //     index: false,
        //     roles: [roles.EnvioNotificacionCliente, roles.Finanzas],
        //     role: 55
        //   }
        // }
      ]
    },
    {
      path: "reportsurvey",
      name: "employeesFinances-reportsurvey",
      component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Respuesta de Empleados",
        index: true,
        // Pass props to the component
        props: {
          // Define your props here
          prop1: "value1",
          prop2: "value2"
          // ...,
        }
      }
    }
  ]
};
